import { createContext, useContext } from "react";
import AccountStore from "./accountStore";
import CommonStore from "./commonStore";
import DialogStore from "./helper/dialogStore";
import ExampleStore from "./exampleStore";
import ModalStore from "./helper/modalStore";
import SnackbarStore from "./helper/snackbarStore";
import UserStore from "./userStore";
import { AssetStore } from "./assetStore";
import RBDStore from "./rbdStore";
import { HomeTrendChartStore } from "./homeTrendChartStore";
import { HomeTableEquipmentStore } from "./homeTableEquipmentStore";
import { RamStore } from "./ramStore";
import { HomeAutoRecommendStore } from "./homeAutoRecommendStore";
import { homeFeatureVisibilityStore } from "./homeFeatureVisibilityStore";

interface Store {
    exampleStore: ExampleStore;
    commonStore: CommonStore;
    accountStore: AccountStore;
    userStore: UserStore;
    snackbarStore: SnackbarStore;
    modalStore: ModalStore;
    dialogStore: DialogStore;
    assetStore: AssetStore;
    rbdStore: RBDStore;
    homeTrendChartStore: HomeTrendChartStore;
    homeTableEquipmentStore: HomeTableEquipmentStore;
    ramStore: RamStore,
    homeAutoRecommendStore: HomeAutoRecommendStore;
    homeFeatureVisibilityStore: homeFeatureVisibilityStore;
}

export const store: Store = {
    exampleStore: new ExampleStore(),
    commonStore: new CommonStore(),
    accountStore: new AccountStore(),
    userStore: new UserStore(),
    snackbarStore: new SnackbarStore(),
    modalStore: new ModalStore(),
    dialogStore: new DialogStore(),
    assetStore: new AssetStore(),
    rbdStore: new RBDStore(),
    homeTrendChartStore: new HomeTrendChartStore(),
    homeTableEquipmentStore: new HomeTableEquipmentStore(),
    ramStore: new RamStore(),
    homeAutoRecommendStore: new HomeAutoRecommendStore(),
    homeFeatureVisibilityStore: new homeFeatureVisibilityStore(),
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}